var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionsList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9398_17150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8266 26.9985H2.74206C2.33145 26.9985 2 26.6646 2 26.2566V16.1716C2 15.7611 2.33393 15.4297 2.74206 15.4297H12.8266C13.2372 15.4297 13.5687 15.7635 13.5687 16.1716V26.2541C13.5712 26.6646 13.2372 26.9985 12.8266 26.9985Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8266 12.5688H2.74206C2.33145 12.5688 2 12.235 2 11.8269V1.74191C2 1.33139 2.33393 1 2.74206 1H12.8266C13.2372 1 13.5687 1.33386 13.5687 1.74191V11.8244C13.5712 12.235 13.2372 12.5688 12.8266 12.5688Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2583 12.5688H17.1737C16.7631 12.5688 16.4316 12.235 16.4316 11.8269V1.74191C16.4316 1.33139 16.7656 1 17.1737 1H27.2583C27.6689 1 28.0003 1.33386 28.0003 1.74191V11.8244C28.0028 12.235 27.6689 12.5688 27.2583 12.5688Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1158 26.8231C25.2551 26.8231 27.8 24.2787 27.8 21.14C27.8 18.0014 25.2551 15.457 22.1158 15.457C18.9765 15.457 16.4316 18.0014 16.4316 21.14C16.4316 24.2787 18.9765 26.8231 22.1158 26.8231Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9398_17150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsList);
export default __webpack_public_path__ + "static/media/optionsList.1083a58ef28cc7afeb78e0ffdb2b93cc.svg";
export { ForwardRef as ReactComponent };